import { instance } from '../../config/axios';
import store from '../index';

const SellerStatus = {
  WORKING: 'working',
  CLOSED: 'closed',
  BREAK: 'break',
  VACATION: 'vacation'
};

const actions = {
  getSettingSeller() {
    return new Promise((resolve, reject) => {
      instance().get(`/sellers/${store.state.currentSellerId}/settings`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  createSettingSeller(_, data) {
    return new Promise((resolve, reject) => {
      instance().post(`/sellers/${store.state.currentSellerId}/settings`, data)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  updateSettingSeller(_, data) {
    return new Promise((resolve, reject) => {
      instance().patch(`/sellers/${store.state.currentSellerId}/settings`, data)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  updateSellerStatus(_, status) {
    return new Promise((resolve, reject) => {
      instance().patch  (`/sellers/${store.state.currentSellerId}/settings`, { status })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  }
};

export default {
  namespaced: true,
  actions
};

export { SellerStatus };